import { TimelineMax, TweenLite, TweenMax } from "gsap";

/*
 This class was written to simplify the switch from using Tweensys tweening engine & TweenLite / TweenMax' engine.
 It's Main purposes are to:
 -Easily add multiple tweens to a single Object without them overwriting eachother
 -Have an oncomplete function called at the end of a group of tweens rather than defining it on a single tween
 * */
export class TweenMaxGroup {
    protected _tweenProperties: TweenProperties[];
    protected _timelines: TimelineMax[];

    constructor() {
        this._tweenProperties = [];
        this._timelines = [];
    }

    public to(target: any, duration: number, vars: any): void {
        this.addTween(target, duration, null, vars, "to");
    }

    public from(target: any, duration: number, fromVars: any): void {
        this.addTween(target, duration, fromVars, null, "from");
    }

    public fromTo(target: any, duration: number, fromVars: any, vars: any): void {
        this.addTween(target, duration, fromVars, vars, "fromTo");
    }

    private addTween(target: any, duration: number, fromVars: any, vars: any, fromTo: string): void {
        var tweenProperty: TweenProperties = new TweenProperties(target, duration, fromVars, vars, fromTo);
        this._tweenProperties.push(tweenProperty);
    }

    public play(onComplete: Function = null, onCompleteParams: any[] = null): void {
        var timelineProperties: TimelineProperties[] = [];
        var complete: boolean = false;
        var tweenProperty: TweenProperties;
        var timelineProperty: TimelineProperties;
        while (!complete) {
            var lowest: TweenProperties = null;
            var best: TimelineProperties = null;
            var newTimeline: TimelineProperties = null;
            for (tweenProperty of this._tweenProperties) {
                if (!tweenProperty.allocated && (!lowest || lowest.start > tweenProperty.start || (lowest.start == tweenProperty.start && lowest.end > tweenProperty.end))) {
                    lowest = tweenProperty;
                }
            }
            if (lowest) {
                for (timelineProperty of timelineProperties) {
                    if (timelineProperty.end <= lowest.start && (!best || timelineProperty.end < best.end)) {
                        best = timelineProperty;
                    }
                }
                if (best) {
                    lowest.vars.delay -= best.end;
                    best.end = lowest.end;
                    best.tweens.push(lowest);
                }
                else {
                    newTimeline = new TimelineProperties(lowest.start, lowest.end);
                    newTimeline.tweens.push(lowest);
                    timelineProperties.push(newTimeline);
                }
                lowest.allocated = true;
            }
            else {
                complete = true;
            }
        }
        var longest: TimelineProperties = null;
        var duration: number = 0;
        var timeline: TimelineMax = null;
        for (timelineProperty of timelineProperties) {
            if (!duration || timelineProperty.end >= duration) {
                longest = timelineProperty;
                duration = timelineProperty.end;
            }
            for (tweenProperty of timelineProperty.tweens) {
                //TweenMax.killTweensOf(tweenProperty.target);
            }
        }
        for (timelineProperty of timelineProperties) {
            if (timelineProperty == longest) {
                timeline = new TimelineMax({ onComplete: onComplete, onCompleteParams: onCompleteParams });
            }
            else {
                timeline = new TimelineMax();
            }
            for (tweenProperty of timelineProperty.tweens) {
                var tween: TweenLite = null;
                if (tweenProperty.fromTo == "fromTo") {
                    tweenProperty.vars.overwrite = 0;
                    //noinspection JSUntypedDeclaration - no type variable required for HTML5 transpiler
                    var prop: string;
                    for (prop in tweenProperty.fromVars) {
                        if (tweenProperty.target && tweenProperty.target.hasOwnProperty(prop)) {
                            tweenProperty.target[prop] = tweenProperty.fromVars[prop];
                        }
                    }
                    tween = TweenMax.fromTo(tweenProperty.target, tweenProperty.duration, tweenProperty.fromVars, tweenProperty.vars);
                }
                else if (tweenProperty.fromTo == "from") {
                    tweenProperty.fromVars.overwrite = 0;
                    tween = TweenLite.from(tweenProperty.target, tweenProperty.duration, tweenProperty.fromVars);
                }
                else {
                    tweenProperty.vars.overwrite = 0;
                    tween = TweenMax.to(tweenProperty.target, tweenProperty.duration, tweenProperty.vars);
                }
                if (tween) {
                    timeline.add(tween);
                }
            }
            this._timelines.push(timeline);
        }
    }

    public destroy(): void {
        if (this._timelines) {
            if (this._timelines != null) {
                for (let entryList of this._timelines) {
                    var timeline: any = entryList;
                    if (timeline === undefined) continue;

                    timeline.kill();
                }
            }
            this._timelines = [];
        }
        this._tweenProperties = [];
    }

    public forceEnd(): void {
        for (var i: number = 0; i < this._timelines.length; i++) {
            this._timelines[i].progress(1);
        }
    }
}

export class TweenProperties {
    public target: any;
    public duration: number = NaN;
    public vars: any;
    public fromTo: string;
    public fromVars: any;
    public start: number = NaN;
    public end: number = NaN;
    public allocated: boolean = false;

    constructor(target: any, duration: number, fromVars: any, vars: any, fromTo: string) {
        this.target = target;
        this.duration = duration;
        this.fromVars = fromVars;
        this.vars = vars;
        this.fromTo = fromTo;
        this.start = 0;
        if (vars && vars.hasOwnProperty("delay")) {
            this.start = Number(vars.delay);
        }
        else if (fromVars && fromVars.hasOwnProperty("delay")) {
            this.start = Number(fromVars.delay);
        }
        this.end = this.start + duration;
        this.allocated = false;
    }
}
export class TimelineProperties {
    public start: number = NaN;
    public end: number = NaN;
    public tweens: TweenProperties[];

    constructor(start: number, end: number) {
        this.start = start;
        this.end = end;
        this.tweens = [];
    }
}
